import React from 'react';
import { useDataLayer, usePageViews } from 'react-common-gdlv2'
import {  Routes, Route } from "react-router-dom";
import { ROUTES } from './config/routes';
import Cardview from './Cardview'
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorPage from './components/ErrorPage';
import Confirmation from './components/Confirmation';
import TimeoutPage from './components/TimeoutPage';
import ErrorBoundary from './components/ErrorBoundary';
import { getBrandCodeDomain } from './utils/utils';
import setTheme from './utils/theme/theme-setter';
import './App.css'

function App () {

  let brand  = getBrandCodeDomain();
  setTheme(brand);

   //GDLV2 instance config
   const { getConfig } = useDataLayer();
   //Automatic page level tracking powered by pageData config
   usePageViews(getConfig())

  return (
    <div className='App'>
      <Header/>
        <main className='App-main'>
          <ErrorBoundary>
              <Routes>
                  <Route exact path={ROUTES.HOME} index element={<Cardview />}></Route>
                  <Route exact path={ROUTES.ERROR_PAGE}  element={<ErrorPage />}></Route>
                  <Route exact path={ROUTES.DISPLAY_CARD} element={<Cardview />} />
                  <Route exact path={ROUTES.CONFIRMATION} element={<Confirmation />} />
                  <Route exact path={ROUTES.TIMEOUT} element={<TimeoutPage />} />
              </Routes>
          </ErrorBoundary>
        </main>
        {/* <div id='data-layer-logs'></div> */}
      <Footer/>
    </div>
  )
}

export default App